/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-shadow */
import { Component, Input, OnInit, EventEmitter, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { UserService } from 'src/app/shared/services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { messagesConfig } from 'src/app/shared/constants/message.constants';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { INotes } from 'src/app/features/models/inotes.modal';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { tableColumns } from 'src/app/shared/constants/table-column.constants';
import { IDropdown } from 'src/app/shared/models/i-dropdown-type.modal';
import { AdminHeader } from 'src/app/shared/models/admin-header.model';
import { AllAdminService } from 'src/app/shared/services/all-admin.service';
import { UtcToLocalPipe } from 'src/app/shared/pipes/utc-to-local.pipe';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { DateTimeUtils } from 'src/app/shared/util/date-time.utils';
import { WorksheetService } from '../../services/worksheet.service';
import { AssignToLabtechComponent } from '../../../../shared/components/assign-to-labtech/assign-to-labtech.component';
import { PrecastWorksheet } from '../../models/precast-worksheet.modal';
import { EditPrecastWorksheetComponent } from '../edit-precast-worksheet/edit-precast-worksheet.component';
import { SelectionModel } from '@angular/cdk/collections';
import { PrecastTechWorksheetPdfService } from './precast-tech-worksheet-pdf.service';
import { WorksheetResponse } from '../../models/worksheet-response.modal';
import { PrecastTechWorksheetExcelService } from './precast-tech-worksheet-excel.service';

@Component({
    selector: 'app-precast-table',
    templateUrl: './precast-table.component.html',
    styleUrls: ['./precast-table.component.scss'],
    providers: [UtcToLocalPipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrecastTableComponent implements OnInit {
  dataSource: MatTableDataSource<PrecastWorksheet>;
  selection = new SelectionModel<PrecastWorksheet>(true,[]);
  @Input() projectId: string;
  @Input() projectStatuses : IDropdown[];
  @Input() projectStatusId : string;

  @Output() assigned = new EventEmitter<boolean>();
  @Output() rowDeletionSuccess = new EventEmitter<void>();
  public worksheets: PrecastWorksheet[];
  private readonly destroyed$ = new Subject<boolean>();
  public note: INotes | undefined;
  public isGray = true;
  public displayedColumns: string[] = tableColumns.worksheetColumns;
  headerData: AdminHeader[] = [];
  rowData: PrecastWorksheet[] = [];
  
  headerKeyToRowKeyMapping: { [key: string]: string } = {
  };

  dragDisabled = true;
  isDataChanged = false;
  data: any = [];
  @ViewChild('table') table: MatTable<any>;

  @Output() allResPrecastWorksheet = new EventEmitter<any>();
  @Output() headerPrecastWorksheet = new EventEmitter<any>();
  @Input() worksheetRecords!: WorksheetResponse;
  deleteBtn = false;
  checkEnableOpentTechWorkSheet = true;
  userRoles: string[];
  constructor(
    public userService: UserService,
    public dialogService: DialogService,
    public dialog: MatDialog,
    private worksheetService: WorksheetService,
    private adminService: AllAdminService,
    private precastTechWorksheetPdfService: PrecastTechWorksheetPdfService,
    private precastTechWorksheetExcelService: PrecastTechWorksheetExcelService
  ) {}

  ngOnInit() {
    this.fetchWorksheet(this.projectId);
    this.getColumnHeader();
    this.userAccountAndRole();
  }

  userAccountAndRole() {
    this.userService.userRole?.subscribe({
      next: (roles) => {
        this.userRoles = roles || [];
      }
    });
  }

  roleCheck(roles: string[]): boolean {
    return roles.some((role) => this.userRoles.includes(role));
  }

  getColumnHeader() {
    this.adminService.getAdminPrecast().subscribe(
      (response) => {
        this.headerData = response;
        this.headerData.sort((a, b) => a.sortOrder - b.sortOrder);
        this.displayedColumns = this.headerData.map((header) => header.key);
        this.displayedColumns.unshift('select');
        this.dataSource = new MatTableDataSource(this.worksheets);
        this.headerPrecastWorksheet.emit(this.headerData);
        this.getColumnkeyMatch();
      },
      (error) => {
        console.error('Error fetching tabs data:', error);
      },
    );
  }

  onMixDesignClick(row: any): void {
    const encodedCode = encodeURIComponent(row.mixDesignCode);
    window.open(`/mix-design/search?mixDesignCode=${encodedCode}`, '_blank');
  }

  checkForEnableOpentTechWorkSheetForLabTech(): boolean {
    const status = this.projectStatuses?.find(
      x => x.id === this.projectStatusId
    );

    var result = !!status && [
      'Samples Due To Arrive',
      'Shipment Received',
      'Awaiting Instructions',
      'Testing In Progress'
    ].includes(status.label);
    return result;
  }

  enableOpenTecWorksheetLabTech(row: any): boolean {
    var status = row.Tech && this.checkForEnableOpentTechWorkSheetForLabTech() && !Boolean(this.isMultipleSelected(row));
    return !status;
  }

  // Match header key value with row key value
  getColumnkeyMatch() {
    this.headerKeyToRowKeyMapping = {
    };
    this.headerData.forEach((header) => {
      this.headerKeyToRowKeyMapping[header.key] = header.key;
    });
  }

  getTooltipText(columnName: string): string {
    const header = this.headerData.find((header) => header.key === columnName);
    return header ? header.tooltipText : '';
  }

  // Displays the header value based on sorted order
  getDisplayName(columnName: string): string {
    const header = this.headerData.find((header) => header.key === columnName);
    if (header) {
      return header.units ? `${header.displayName} <br>${header.units}` : header.displayName;
    }
    return '';
  }

  // Displays the column row value
  getRowDataByKey(row: any, key: string): string {
    const rowKey = this.headerKeyToRowKeyMapping[key];
    const value = row[rowKey];
    // Custom date formatting for 'castDate',columns
    if (key === 'castDate') {
      if (value === null) {
        return '';
      }
      return DateTimeUtils.formatDateAndTime(value, 'MM/dd/yyyy');
    }

    if (key === 'assignedTo') {
      if (value && value.firstName && value.lastName) {
        return `${value.firstName} ${value.lastName}`;
      }
      return '';
    }
    return value;
  }

  isLastRowOfSample(row: PrecastWorksheet, index: number): boolean {
    const currentSampleId = row.sampleId;
    const nextRow = this.dataSource.data[index + 1];

    if (!nextRow) return false;
    return nextRow.sampleId !== currentSampleId;
  }

  isMergeColumn(column: string): column is keyof PrecastWorksheet {
    return ['inHouseId', 'sampleId', 'castDate', 'sampleType', 'mixDesignCode', 'tare', 'sampleDiameter', 
      'sampleHeight', 'volume', 'dryPlusTare', 'drySoilWeight', 'dryTr', 'density', 'assignedTo', 'select'].includes(column);
  }

  getSpan(row: PrecastWorksheet, column: string): number {
    return this.isMergeColumn(column) ? this.getRowSpan(row, column) : 1;
  }

  isHidden(row: PrecastWorksheet, column: string): boolean {
    return this.isMergeColumn(column) && this.getRowSpan(row, column) === 0;
  }

  isParentRow(row: PrecastWorksheet): boolean {
    return this.displayedColumns
      .filter(col => this.isMergeColumn(col))
      .some(col => this.getRowSpan(row, col as keyof PrecastWorksheet) > 0);
  }

  private isAssignedTo(v: any): v is { firstName: string; lastName: string } {
    return (
      v &&
      typeof v === 'object' &&
      !Array.isArray(v) &&
      typeof v.firstName === 'string' &&
      typeof v.lastName === 'string'
    );
  }

  private compareAssignedTo(a: any, b: any): boolean {
    if (this.isAssignedTo(a) && this.isAssignedTo(b)) {
      return a.firstName === b.firstName && a.lastName === b.lastName;
    }
    return false;
  }

  getRowSpan(element: PrecastWorksheet, column: keyof PrecastWorksheet): number {
    const index = this.dataSource.data.indexOf(element);
    if (index === -1) return 1;

    const prev = this.dataSource.data[index - 1];
    const currValue = element[column];

    if (prev && prev.sequence !== undefined && element.sequence !== undefined) {
      const prevValue = prev[column];

      const sameValue =
        column === 'assignedTo'
          ? this.compareAssignedTo(prevValue, currValue)
          : prevValue === currValue;

      if (sameValue && (prev.sequence % 2) === (element.sequence % 2)) {
        return 0;
      }
    }

    let count = 1;
    for (let i = index + 1; i < this.dataSource.data.length; i++) {
      const next = this.dataSource.data[i];
      const nextValue = next[column];
      if (next.sequence === undefined || element.sequence === undefined) {
        break;
      }

      const sameValue =
        column === 'assignedTo'
          ? this.compareAssignedTo(nextValue, currValue)
          : nextValue === currValue;

      if (sameValue && (next.sequence % 2) === (element.sequence % 2)) {
        count++;
      } else {
        break;
      }
    }

    return count;
  }

  openAssignToDialog(worksheetId: string): void {
    this.dialog
      .open(AssignToLabtechComponent, {
        data: {
          worksheetId,
          type: 'precast',
          multipleSelected : this.isMultipleSelected(worksheetId),
          worksheetRows : this.selection.selected,
          totalNumOfWorksheets: this.dataSource.data.length,
          role: this.userRoles
        },
        disableClose: true,
        width: '40%',
      })
      .afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((assigned) => {
        if (assigned) {
          this.fetchWorksheet(this.projectId);
          this.rowDeletionSuccess.emit();
          this.assigned.emit(true);
        }
      });
  }

  shouldHideSortColumn(): boolean {
    const totalRows = this.dataSource.data.length;
    const parentRowsCount = this.dataSource.data.filter((row) => row.groupOrder === 0).length;

    return (
      totalRows === 1
      || (totalRows > 1 && parentRowsCount === 1)
      || !this.isUserManagerOrAdmin()
    );
  }

  isUserManagerOrAdmin(): boolean {
    return this.roleCheck(['Manager', 'Admin']);
  }

  onDrop(event: CdkDragDrop<any[]>) {
    this.dragDisabled = true;
    const draggedRow = event.item.data;
    const { currentIndex } = event;

    const selectedRows = this.getGroupRows(draggedRow);
    const droppedRow = this.dataSource.data[currentIndex];

    if (draggedRow.groupOrder === 0) {
      const isDroppedOnChild = this.getGroupRows(droppedRow).some((row: any) => row.inHouseId === draggedRow.inHouseId);

      if (isDroppedOnChild) {
        return;
      }

      const dummy: any = [];
      
      const selectedDropRows = this.getDroppedRows(droppedRow);
      const previousIndex = this.dataSource.data.findIndex((d) => d.inHouseId === draggedRow.inHouseId);

      this.dataSource.data.forEach((each: any, i: number) => {
        if (selectedRows[0].inHouseId !== each.inHouseId && droppedRow.inHouseId !== each.inHouseId) {
          dummy.push(each);
        } else {
          dummy.push({
            inHouseId: null,
          });
        }

        if (i === currentIndex) {
          if (currentIndex === previousIndex) {
            dummy.push(...selectedDropRows);
          } else if (currentIndex > previousIndex) {
            dummy.push(...selectedDropRows);
            dummy.push(...selectedRows);
            this.isDataChanged = true;
          } else {
            dummy.push(...selectedRows);
            dummy.push(...selectedDropRows);
            this.isDataChanged = true;
          }
        }
      });

      const actualObject: any = [];
      let i = 0;
      dummy.forEach((elem: any) => {
        if (elem.inHouseId !== null) {
          actualObject.push(elem);
        }
      });
      this.dataSource.data = actualObject;
      this.dataSource.data.forEach((elem:any) => {
        elem.sortOrder = i + 1;
        i += 1;
      });
      this.table.renderRows();
    }
  }

  saveWorksheet() {
    this.worksheetService.updateWorksheetSortingPrecast(this.dataSource.data).subscribe(
      (response) => {
        this.fetchWorksheet(this.projectId);
      },
      (error) => {
        console.error('Error saving data', error);
      },
    );
    this.table.renderRows();
    this.isDataChanged= false;
  }

  getGroupRows(row: PrecastWorksheet): PrecastWorksheet[] {
    if (row.groupOrder === 0) {
      return this.worksheets.filter((worksheet) => worksheet.inHouseId === row.inHouseId);
    }
    return [row];
  }

  getDroppedRows(row: PrecastWorksheet): PrecastWorksheet[] {
    return this.worksheets.filter((worksheet) => worksheet.inHouseId === row.inHouseId);
  }

  fetchWorksheet(projectId: string): void {
    this.worksheetService
      ?.fetchWorksheetbyId(projectId)
      ?.pipe(takeUntil(this.destroyed$))
      ?.subscribe({
        next: (worksheets) => {
          let initial = 0;
          this.worksheets = worksheets;
          const fetchWorksheet = JSON.parse(JSON.stringify(worksheets));
          const countGroupOrder = this.worksheets.filter((worksheet) => worksheet.groupOrder === 0 || worksheet.groupOrder === null);
          this.worksheets.forEach((worksheet) => {
            if (!worksheet.groupOrder) {
              initial += 1;
            }
            worksheet.sequence = initial;
          });
          this.selection.clear();
          this.dataSource = new MatTableDataSource<PrecastWorksheet>(this.worksheets);
          fetchWorksheet.forEach((worksheet:PrecastWorksheet) => {
            if (worksheet.truckNumber && worksheet.ticketNumber) {
              worksheet.sampleId = `${worksheet.sampleId}, Truck# ${worksheet.truckNumber}, Ticket# ${worksheet.ticketNumber}`;
            } else if (worksheet.ticketNumber) {
              worksheet.sampleId = `${worksheet.sampleId}, Ticket# ${worksheet.ticketNumber}`;
            } else if (worksheet.truckNumber) {
              worksheet.sampleId = `${worksheet.sampleId}, Truck# ${worksheet.truckNumber}`;
            } else {
              worksheet.sampleId = `${worksheet.sampleId}`;
            }
            worksheet.groupOrder = (worksheet.groupOrder ?? 0) + 1;
          });

          fetchWorksheet.forEach((worksheet:any) => {
            if (worksheet.assignedTo) {
              const updatedByFirstName = worksheet.assignedTo?.firstName;
              const updatedByLastName = worksheet.assignedTo?.lastName;
              worksheet.assignedTo = `${updatedByFirstName} ${updatedByLastName}`;
            }
          });

          fetchWorksheet.forEach((worksheet: any) => {
            if (worksheet.castDate) {
              const formattedCastDate = DateTimeUtils.formatDateAndTime(worksheet.castDate, 'MM/dd/yyyy');
              worksheet.castDate = `${formattedCastDate} `;
            }
          });

          // this emit logic only for excel preview and download excel file
          this.allResPrecastWorksheet.emit(fetchWorksheet);
          if (countGroupOrder.length > 1) {
            this.deleteBtn = false;
          } else {
            this.deleteBtn = true;
          }
          this.checkEnableOpentTechWorkSheet = this.checkForEnableOpentTechWorkSheet();
        },
      });
  }

  editWorksheet(element: PrecastWorksheet, adminOrManager: boolean): void {
    let worksheets;
    if (adminOrManager) {
      worksheets = this.worksheets.filter((worksheet) => !worksheet.groupOrder);
    } else {
      worksheets = this.worksheets.filter((worksheet) => !worksheet.groupOrder && worksheet.Tech);
    }

    this.dialog
      .open(EditPrecastWorksheetComponent, {
        panelClass: 'worksheet-dialog',
        data: {
          element,
          worksheets,
          mode: 'UPDATE',
          role: this.userRoles
        },
        disableClose: true,
        width: '50%',
      })
      .afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((mode: string) => {
        if (mode !== 'close') {
          this.fetchWorksheet(this.projectId);
          this.rowDeletionSuccess.emit();
        }
      });
  }

  deleteWorksheet(element: string): void {
    if (this.worksheets.length > 1) {
      this.dialog
        .open(ConfirmationDialogComponent, {
          panelClass: 'worksheet-dialog',
          data: {
            title: 'Delete',
            content: 'Are you sure you want to delete?',
          },
          disableClose: true,
        })
        .afterClosed()
        .pipe(takeUntil(this.destroyed$))
        .subscribe((response?: string) => {
          if (response === 'YES') {
            this.worksheetService
              .deleteWorksheet(element)
              .pipe(takeUntil(this.destroyed$))
              .subscribe({
                next: () => {
                  this.fetchWorksheet(this.projectId);
                  this.rowDeletionSuccess.emit();
                  this.dialogService.open(messagesConfig.worksheetDeleteMessage);
                },
                error: () => {},
              });
          }
        });
    } else {
      this.dialogService.open(messagesConfig.worksheetDeleteValidation);
    }
  }

  checkForEnableOpentTechWorkSheet() : boolean {
    if (this.projectStatuses && this.projectStatuses.length > 0) {
      const index = this.projectStatuses.findIndex((x) => x.id === this.projectStatusId);
      if (index > -1) {
        switch (this.projectStatuses[index].label) {
          case 'Samples Due To Arrive':
          case 'Shipment Received':
          case 'Awaiting Instructions':
          case 'Testing In Progress':
            this.checkEnableOpentTechWorkSheet = false;
            return this.checkEnableOpentTechWorkSheet;
            break;
          default:
        }
      }
    }
    return false;
  }

  enableOpenTecWorksheet(rowStatus: boolean, assignTo: string) {
    if (!rowStatus && assignTo) {
      return false;
    } if (rowStatus) {
      return false;
    }
    return true;
  }

  isAllSelected() {
    return this.selection.selected.length === this.dataSource.data.length;
  }

  isIndeterminate() {
    return this.selection.selected.length > 0 && !this.isAllSelected();
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.selection.select(...this.dataSource.data);
    }
  }

  toggleSelection(row: PrecastWorksheet) {
    const index = this.selection.selected.indexOf(row);
    if (index >= 0) {
      this.selection.selected.splice(index, 1);
    } else {
      this.selection.selected.push(row);
    }
  }

  isMultipleSelected(row: any): boolean {
    return this.selection.selected.length >= 1 && this.selection.selected.includes(row);
  }

  downloadTRWorksheet() {
    this.precastTechWorksheetPdfService.generateTRWorksheet(
      this.worksheetRecords,
      this.worksheets,
    );
  }

  downloadWorksheetReport() {
    this.precastTechWorksheetExcelService.generateWorksheetReport(
      this.worksheetRecords,
      this.worksheets,
    );
  }
}
